var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFav(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 10,
    viewBox: "0 0 29 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2201 1.60156V8H11.6776V1.60156H13.2201ZM15.7074 4.26465V5.45117H12.7807V4.26465H15.7074ZM15.9579 1.60156V2.79248H12.7807V1.60156H15.9579Z",
    fill: "#75EB00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3672 2.94629L17.8071 8H16.1504L18.5015 1.60156H19.5518L19.3672 2.94629ZM20.6592 8L19.0947 2.94629L18.8926 1.60156H19.9561L22.3203 8H20.6592ZM20.5977 5.61377V6.80469H17.3149V5.61377H20.5977Z",
    fill: "#75EB00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7691 6.49268L27.1007 1.60156H28.8277L26.67 8H25.5538L25.7691 6.49268ZM24.5606 1.60156L25.8922 6.49268L26.1163 8H24.9869L22.8424 1.60156H24.5606Z",
    fill: "#75EB00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.55469 0.441406L6.69727 2.7793L9.21094 3.14844C9.42187 3.18359 9.59766 3.32422 9.66797 3.53516C9.73828 3.72852 9.68555 3.95703 9.52734 4.09766L7.69922 5.9082L8.13867 8.47461C8.17383 8.68555 8.08594 8.89648 7.91016 9.01953C7.73437 9.16016 7.50586 9.16016 7.3125 9.07227L5.0625 7.85938L2.79492 9.07227C2.61914 9.16016 2.39062 9.16016 2.21484 9.01953C2.03906 8.89648 1.95117 8.68555 1.98633 8.47461L2.4082 5.9082L0.580078 4.09766C0.439453 3.95703 0.386718 3.72852 0.439453 3.53516C0.509765 3.32422 0.685546 3.18359 0.896484 3.14844L3.42773 2.7793L4.55273 0.441406C4.64062 0.248047 4.83398 0.125 5.0625 0.125C5.27344 0.125 5.4668 0.248047 5.55469 0.441406Z",
    fill: "#75EB00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFav);
export default ForwardRef;